export type CommonColumns = {
  id: string;
  uuid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
};

export const commonColumns: CommonColumns = {
  id: 'ID',
  uuid: 'UUID',
  createdAt: '作成日時',
  updatedAt: '更新日時',
  deletedAt: '削除日時',
};
